module.exports = __webpack_public_path__ + "img/cbn.6587c184.png";